module.exports = __webpack_public_path__ + "static/media/cert_125.9efb0858.jpg";